import React from 'react';
import { Images } from 'utils';
import { systemItemStyles } from './styles';

export const SystemItemHeader = ({}) => {
    const classes = systemItemStyles();

    return (
        <div className={classes.spaceBottom}>
            <div className={classes.systemHeaderStyles}>
                <img
                    style={{filter: 'brightness(0) saturate(100%) invert(26%) sepia(80%) saturate(2397%) hue-rotate(206deg) brightness(93%) contrast(92%)'}}
                    src={Images.systemIcon}
                    alt="founding"
                    className={classes.systemIcon}
                />
                <p className={classes.systemTitle}>Practice Settings</p>
            </div>
        </div>
    );
};
